import * as GoogleMapsLoader from 'google-maps'

const availableFields = ['formatted_address', 'geometry', 'icon', 'id', 'name', 'permanently_closed', 'photos', 'place_id', 'plus_code', 'scope', 'types', 'user_ratings_total']
const defaultFields = ['geometry']

export default class AddressConverter {
  constructor () {
    if (!process.env.VUE_APP_GOOGLE_MAPS_API_KEY) {
      throw new Error('Please provide google maps api key from env (VUE_APP_GOOGLE_MAPS_API_KEY)')
    }

    this.hasLoaded = false
    this.latestQuery = undefined
    GoogleMapsLoader.KEY = process.env.VUE_APP_GOOGLE_MAPS_API_KEY
    GoogleMapsLoader.LIBRARIES.push('places')
    GoogleMapsLoader.load(this.load.bind(this))
    return

  }

  load (google) {
    /* eslint-disable no-new */
    this.google = google
    this.placesService = new google.maps.places.PlacesService(document.createElement('div'))
    this.hasLoaded = true
  }

  addressToCoords (address, forceRequest, fields = ['formatted_address', 'geometry']) {
    if (this.hasLoaded) {
      address = this.sanitizeAddress(address)
      fields = this.sanitizeFields(fields)

      let request = { fields, query: Object.values(address).filter(e => e).join('; ') }

      //console.log(`Searching for: ${request.query}`)
      return new Promise((resolve, reject) => {
        if (forceRequest || !(this.latestQuery !== undefined && this.latestQuery.toLowerCase() === request.query.toLowerCase())) {
          this.latestQuery = request.query
        } else {
          resolve(null)
        }

        this.placesService.findPlaceFromQuery(request, (results, status) => {
          let result = false
          if (status === this.google.maps.places.PlacesServiceStatus.OK) {
            result = {
              lat: results[0].geometry.location.lat(),
              lng: results[0].geometry.location.lng()
            }
            if (fields.includes('formatted_address')) {
              result.formattedAddress = results[0].formatted_address
            }
          }
          resolve(result)
        })
      })
    }
    throw new Error('Service has not loaded yet.')
  }

  sanitizeAddress (address) {
    let sanitizedAddress = JSON.parse(JSON.stringify(address))
    delete sanitizedAddress.id
    delete sanitizedAddress.lat
    delete sanitizedAddress.lng
    return sanitizedAddress
  }

  sanitizeFields (fields) {
    return (fields && fields.length > 0) ? fields.filter(value => availableFields.includes(value)) : defaultFields
  }
}
